var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"works"},[_c('NavBar',{attrs:{"white":true}}),_c('WorksContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }